import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Box } from 'grid-styled';

import Input from 'components/Input/Input';
import LoginView from 'components/LoginView/LoginView';
import Button from 'components/Button/Button';
import P from 'components/P/P';

import messages from './messages';
import { isEmailValid } from '../../utils/email';

@inject('authStore')
@observer
class ForgotLoginView extends React.Component {
  state = {
    username: '',
    resetSuccess: false
  };

  async handleSubmit(event) {
    event.preventDefault();
    const { authStore } = this.props;
    const { username } = this.state;
    await authStore.forgotPassword(username);
    this.setState({ resetSuccess: true });
  }
  updateUsername(event) {
    this.setState({ username: event.target.value });
  }

  render() {
    const { username, resetSuccess } = this.state;
    const { intl: { formatMessage } } = this.props;

    const title = formatMessage(messages.forgotTitle);
    const message = formatMessage(messages.forgotMessage);
    return (
      <LoginView title={title} message={message}>
        {resetSuccess && (
          <Box mb={10}>
            <P>
              {' '}
              <FormattedMessage {...messages.forgotSuccessMessage} />
            </P>
          </Box>
        )}
        {!resetSuccess && (
          <form onSubmit={e => this.handleSubmit(e)}>
            <Box mb={20}>
              <Input
                placeholder={formatMessage(messages.forgotEmail)}
                onChange={e => this.updateUsername(e)}
                value={username}
                type="text"
              />
            </Box>
            <Button disabled={!username || !isEmailValid(username)} secondary>
              <FormattedMessage {...messages.forgotSubmitButton} />
            </Button>
          </form>
        )}
      </LoginView>
    );
  }
}

export default injectIntl(ForgotLoginView);



// WEBPACK FOOTER //
// ./src/containers/login/ForgotLoginView.js